import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconLayers = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconLayers.dimensions.width} ${IconLayers.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill="none"
        stroke={color || Color.premiumBlack}
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="m11.04 21.676-9.785-6.827a.576.576 0 0 1 .017-.967l9.776-6.359a.631.631 0 0 1 .677 0l9.776 6.36a.575.575 0 0 1 .017.966l-9.776 6.827a.626.626 0 0 1-.71 0h.008Z"
      />
      <Path
        fill="none"
        stroke={color || Color.premiumBlack}
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="m11.04 18.66-9.785-6.826a.576.576 0 0 1 .017-.967l9.776-6.36a.631.631 0 0 1 .677 0l9.776 6.36a.575.575 0 0 1 .017.966l-9.776 6.827a.626.626 0 0 1-.71 0h.008Z"
      />
      <Path
        fill="none"
        stroke={color || Color.premiumBlack}
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M11.04 15.243 1.255 8.416a.576.576 0 0 1 .017-.967l9.785-6.35a.631.631 0 0 1 .676 0l9.777 6.359a.576.576 0 0 1 .017.967L11.75 15.25a.626.626 0 0 1-.71 0v-.008Z"
      />
    </Svg>
  )
}

IconLayers.dimensions = {
  width: 22,
  height: 22,
}

export default IconLayers
